/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 23.05.2016.
 */


import React, {Component} from 'react';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _get from 'lodash/get';

import {GetPackages} from '../actions/collection/actions-collection';

import Translate from '../components/Translate';
import EPGGridPage from '../containers/Epg';
import EpgClassicView from '../containers/EpgClassicView';

class EPGRoute extends Component {
  componentWillMount() {
    this.props.GetPackages();
  }

  render() {

    if (_get(this.props, 'params.channel_id')) {

      return <EpgClassicView channelId={_get(this.props, 'params.channel_id')} location={this.props.location} />;

    } else {

      return <DocumentTitle title={Translate.translator('page.epg')}>
        <EPGGridPage />
      </DocumentTitle>;
    }

  }
}

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({GetPackages}, dispatch);
};

export default connect(() => ({}), mapDispatchToProps)(EPGRoute);



// WEBPACK FOOTER //
// ./src/routes/epg-route.js